import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { GuaranteeTypeInsertService } from '../../service/guarantee-type-insert/guarantee-type-insert.service';

@Component({
	selector: 'app-guarantee-type-insert',
	templateUrl: './guarantee-type-insert.component.html',
	providers: [
		GuaranteeTypeInsertService,
		HttpModule
	]
})
export class GuaranteeTypeInsertComponent implements OnInit {

	private token;
	guaranteeType: FormGroup;
	Nome: string = "";
	statusGuaranteeType: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private guaranteeTypeInsertService: GuaranteeTypeInsertService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.guaranteeType = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addGuaranteeType(value: any) {
		this.guaranteeTypeInsertService.insertCompanyType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/tipo-garantia');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-garantia');
	}

}



// WEBPACK FOOTER //
// ./src/app/guarantee-type/component/guarantee-type-insert/guarantee-type-insert.component.ts